export const getInvoiceLinkPath = () => '/i/:token';
